import { ChangeDetectorRef, Component, HostListener, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { ThemeMode } from '@fleet-beat/core';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, Subject } from 'rxjs';

/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable change-detection-strategy/on-push */
@Component({
  template: '',
})
export abstract class SimpleField<Data> extends OnDestroyMixin implements ControlValueAccessor {
  @Input() set currentThemeSubject(value: ThemeMode) {
    this._currentThemeSubject.next(value);
  }

  _currentThemeSubject: BehaviorSubject<ThemeMode> = new BehaviorSubject(undefined);

  @Input()
  set disable(value: boolean) {
    this.innerDisabled = Boolean(value);
    this.stateChanges.next();
  }

  get disable(): boolean {
    return this.innerDisabled;
  }

  @Input()
  set value(value: Data) {
    if (this.valueSubject.getValue() !== value) {
      this.valueSubject.next(value);
      if (this.onChanged) {
        this.onChanged(value);
      }

      this.stateChanges.next();
    }
  }

  get value(): Data {
    return this.valueSubject.getValue();
  }

  @Input()
  set required(value: boolean) {
    this.requiredSubject.next(value);
  }
  get required(): boolean {
    return this.requiredSubject.value;
  }

  stateChanges: Subject<void> = new Subject();

  @Input() appearance: MatFormFieldAppearance;
  @Input() label: string;
  @Input() placeholder: string;

  @Input() readonly: boolean = false;

  touched: boolean = false;
  onChanged: (value: Data) => void;

  protected valueSubject: BehaviorSubject<Data> = new BehaviorSubject(undefined);
  protected requiredSubject: BehaviorSubject<boolean> = new BehaviorSubject(undefined);

  private innerDisabled: boolean = false;
  private initValue: Data;

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    protected ngControl: NgControl,
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  registerOnChange(fn: (value: Data) => void): void {
    this.onChanged = fn;
    this.changeDetectorRef.markForCheck();
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  onTouched(): void {
    this.touched = true;
  }

  writeValue(value: Data): void {
    this.value = value;
    this.initValue = value;
    this.onWriteValue(value);
    this.changeDetectorRef.markForCheck();
  }

  /* eslint-disable-next-line */
  protected onWriteValue(value: Data): void {}
}
